import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-token-modal',
    templateUrl: './token-modal.component.html',
    styleUrls: ['./token-modal.component.scss'],
    standalone: false
})
export class TokenModalComponent implements OnInit {

  constructor() { }

  timeToExpire = 0;
  timer = null;
  parsedTime = '';
  expiredSession = false;
  token = null;

  @Output() extendSessionEvent = new EventEmitter();
  @Output() refreshPageEvent = new EventEmitter();

  ngOnInit(): void {

  }

  startTimer() {

    if (this.timer)
      this.stopTimer();
    
    this.timer = setInterval(() => {
      
      this.timeToExpire--;
      const minutes = Math.floor(this.timeToExpire / 60);
      const seconds = Math.floor(this.timeToExpire % 60);

      const timeLeft = this.token.exp - new Date().getTime() / 1000;


      if (this.timeToExpire <= 0 || timeLeft <= 0) {
        clearInterval(this.timer);
        this.expiredSession = true;
        return;
      }

      if (minutes <= 0) {
        this.parsedTime = `${seconds} seconds`;
        return;
      }

      this.parsedTime = `${minutes} minutes and ${seconds} seconds`;

    }, 1000);
  }

  stopTimer() {
    clearInterval(this.timer);
  }

  extendSession(){
    this.stopTimer();
    this.extendSessionEvent.emit();
  }

  refreshPage() {
    this.stopTimer();
    this.refreshPageEvent.emit();
  }

}
